<ng-container *ngIf="landing">
  <div class="sticky-top">
    <header class="navbar navigation">
      <div class="d-flex align-items-center">
        <span class="logo clickable" routerLink="/"></span>
        <ul class="navlinks d-flex align-items-center ml-4 desktop-only">
          <li class="pages">
            <a *ifLanguage="'pt'" [routerLink]="'/agenda'">{{ 'LANDING.nav.calendar' | translate }}</a>
            <a *ifLanguage="'!pt'" [routerLink]="'/calendar'">{{ 'LANDING.nav.calendar' | translate }}</a>
          </li>
          <li class="pages">
            <a *ifLanguage="'pt'" [routerLink]="'/pagina-marcacoes'">{{ 'LANDING.nav.bookingPage' | translate }}</a>
            <a *ifLanguage="'!pt'" [routerLink]="'/booking-page'">{{ 'LANDING.nav.bookingPage' | translate }}</a>
          </li>
          <li>
            <a [routerLink]="[]" fragment="pricing" (click)="analyticsEvent('navbar-pricing')">{{ 'LANDING.nav.pricing' | translate }}</a>
          </li>
        </ul>
      </div>
      <ul class="navlinks d-flex align-items-center">
        <li class="desktop-only" *ngIf="salesPhone">
          <a (click)="analyticsEvent('navbar-phone')" class="btn btn-md btn-secondary d-flex align-items-center"
          href="tel:{{salesPhone}}"><i class="material-icons ico mr-1">call</i>{{salesPhone}}</a
          >
        </li>
        <li>
          <button (click)="analyticsEvent('navbar-login')" class="btn btn-md btn-secondary" routerLink="/login">{{ landing.login }}</button>
        </li>
        <li>
          <button (click)="analyticsEvent('navbar-signup')" class="btn btn-md btn-primary desktop-only" routerLink="/signup">
            {{ 'LANDING.landing.registerCta' | translate }}
          </button>
          <button (click)="analyticsEvent('navbar-signup')" class="btn btn-md btn-primary mobile-only" routerLink="/signup">
            {{ 'LANDING.landing.registerCta2' | translate }}
          </button>
        </li>
        <li class="mobile-only">
          <span class="material-icons ico-mobile-menu text-primary" (click)="toggleMobileNav()">menu</span>
        </li>
        <li class="desktop-only">
          <app-language-picker />
        </li>
      </ul>
    </header> 
  </div> 
  <app-google-auth [showPrompt]="true" type="signup"></app-google-auth>

  <div class="mobile-nav-overlay" (click)="toggleMobileNav()" *ngIf="showMobileNav"></div>
  <div class="mobile-nav" [ngClass]="{ navAnim: showMobileNav }">
    <div class="container">
      <div class="row">
        <div class="col">
          <i class="material-icons icon" (click)="toggleMobileNav()">close</i>
          <ul>
            <li>
              <a [routerLink]="language === 'pt' ? '/agenda' : '/calendar'">{{ 'LANDING.nav.calendar' | translate }}</a>
            </li>
            <li>
              <a [routerLink]="language === 'pt' ? '/pagina-marcacoes' : '/booking-page'">{{ 'LANDING.nav.bookingPage' | translate }}</a>
            </li>
            <li>
              <a [href]="language === 'pt' ? '/pagina-marcacoes#pricing' : '/booking-page#pricing'"
              (click)="toggleMobileNav(); analyticsEvent('navbar-pricing')">{{ 'LANDING.nav.pricing' | translate}}</a>
            </li>
            <li>
              <a routerLink="/faqs">{{ 'LANDING.landing.faqs' | translate }}</a>
            </li>
            <li>
              <app-language-picker />
            </li>
          </ul>
          <div class="d-flex flex-column justify-content-center mb-3 mobile-only">
            <a
              *ngIf="salesPhone"
              (click)="analyticsEvent('navbar-phone')"
              class="btn btn-lg btn-secondary d-flex align-items-center mb-3"
              href="tel:{{salesPhone}}"
              ><i class="material-icons ico mr-1">call</i>{{salesPhone}}</a
            >
            <button (click)="analyticsEvent('navbar-signup')" class="btn btn-lg btn-primary" routerLink="/signup">
              {{ landing.registerCta }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- <header class="navbar navigation fixed-top">
    <div class="d-flex align-items-center">
      <span class="logo clickable" routerLink="/"></span>
      <ul class="navlinks d-flex align-items-center ml-4 desktop-only">
        <li class="pages">
          <a [routerLink]="language === 'pt' ? '/agenda' : '/calendar'">{{ 'LANDING.nav.calendar' | translate }}</a>
        </li>
        <li class="pages">
          <a [routerLink]="language === 'pt' ? '/pagina-marcacoes' : '/booking-page'">{{ 'LANDING.nav.bookingPage' | translate }}</a>
        </li>
        <li>
          <a [href]="language === 'pt' ? '/pagina-marcacoes#pricing' : '/booking-page#pricing'" (click)="analyticsEvent('navbar-pricing')">{{ 'LANDING.nav.pricing' | translate }}</a>
        </li>
      </ul>
    </div>
    <ul class="navlinks d-flex align-items-center">
      <li class="desktop-only" *ngIf="salesPhone">
        <a (click)="analyticsEvent('navbar-phone')" class="btn btn-md btn-secondary d-flex align-items-center" href="tel:{{salesPhone}}"
          ><i class="material-icons ico mr-1">call</i>{{salesPhone}}</a
        >
      </li>
      <li>
        <button (click)="analyticsEvent('navbar-login')" class="btn btn-md btn-secondary" routerLink="/login">{{ landing.login }}</button>
      </li>
      <li>
        <button (click)="analyticsEvent('navbar-signup')" class="btn btn-md btn-primary desktop-only" routerLink="/signup">
          {{ 'LANDING.landing.registerCta' | translate }}
        </button>
        <button (click)="analyticsEvent('navbar-signup')" class="btn btn-md btn-primary mobile-only" routerLink="/signup">
          {{ 'LANDING.landing.registerCta2' | translate }}
        </button>
      </li>
      <li class="mobile-only">
        <span class="material-icons ico-mobile-menu text-primary" (click)="toggleMobileNav()">menu</span>
      </li>
      <li class="desktop-only">
        <app-language-picker />
      </li>
    </ul>
  </header> -->

  <section class="hero-2 bg-2 text-primary hero-correct">
    <div class="container-fluid">
      <div class="row align-items-center flex-md-row-reverse">
        <div class="col-md-6 mb-4">
          <img responsiveImg url="nl3-hero.png" mobileWidth="600" desktopWidth="1100" nolazy alt="" class="nl-1" />
        </div>
        <div class="col-md-6">
          <h1 class="h1-2 mb-4">{{ 'LANDING.landBookingPage.hero.title' | translate }}</h1>
          <p class="large">{{ 'LANDING.landBookingPage.hero.desc' | translate }}</p>
          <div class="d-flex justify-content-start mb-3 desktop-only">
            <button (click)="analyticsEvent('bookingPage-hero-signup')" class="btn btn-lg btn-primary mr-3" routerLink="/signup">
              {{ landing.registerCta }}
            </button>
            <a
              (click)="analyticsEvent('bookingPage-hero-demo')"
              class="btn btn-lg btn-outline"
              target="_blank"
              [href]="toolsService.getDemoLink()"
              >{{ landing.contactCta }}</a
            >
          </div>
          <div class="d-flex flex-column justify-content-center mb-3 mobile-only">
            <button (click)="analyticsEvent('bookingPage-hero-signup')" class="btn btn-lg btn-primary mb-3" routerLink="/signup">
              {{ landing.registerCta }}
            </button>
            <a
              (click)="analyticsEvent('bookingPage-hero-demo')"
              class="btn btn-lg btn-outline"
              target="_blank"
              [href]="toolsService.getDemoLink()"
              >{{ landing.contactCta }}</a
            >
          </div>
          <a routerLink="/signup" *ifCountry="'pt'">
            <p class="pro-code text-gray small mb-5">
              ⚡️ {{ 'LANDING.landing.promoCopy' | translate }}
            </p>
          </a>
          <a routerLink="/signup" *ifCountry="'es'">
            <p class="pro-code text-gray small mb-5">
              ⚡️ {{ 'LANDING.pricing.tryPro' | translate }}
            </p>
          </a>
        </div>
      </div>
    </div>
  </section>

  <section class="n-section block-feat pt-5 pb-5">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-md-6 mb-3">
          <img responsiveImg url="nl3-1.png" mobileWidth="400" desktopWidth="820" alt="" />
        </div>
        <div class="col-md-6 mb-3">
          <div class="section-content">
            <h2 class="h2-2 text-primary mb-4">{{ 'LANDING.landBookingPage.feat1.title' | translate }}</h2>
            <p class="large text-gray">{{ 'LANDING.landBookingPage.feat1.desc' | translate }}</p>
            <ul class="text-gray check-list mb-4">
              <li><i class="material-icons ico">check_circle</i>{{ 'LANDING.landBookingPage.feat1.check1' | translate }}</li>
              <li><i class="material-icons ico">check_circle</i>{{ 'LANDING.landBookingPage.feat1.check2' | translate }}</li>
            </ul>
            <button (click)="analyticsEvent('bookingPage-customPage-signup')" class="btn btn-lg btn-secondary mb-3" routerLink="/signup">
              {{ landing.registerCta }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="n-section block-feat pt-5 pb-5">
    <div class="container">
      <div class="row align-items-center flex-md-row-reverse">
        <div class="col-md-6 mb-3">
          <img responsiveImg url="nl3-2.png" mobileWidth="400" desktopWidth="820" alt="" />
        </div>
        <div class="col-md-6 mb-3">
          <div class="section-content">
            <h2 class="h2-2 text-primary mb-4">{{ 'LANDING.landBookingPage.feat2.title' | translate }}</h2>
            <ul class="text-gray check-list mb-4">
              <li><i class="material-icons ico">check_circle</i>{{ 'LANDING.landBookingPage.feat2.check1' | translate }}</li>
              <li><i class="material-icons ico">check_circle</i>{{ 'LANDING.landBookingPage.feat2.check2' | translate }}</li>
              <li><i class="material-icons ico">check_circle</i>{{ 'LANDING.landBookingPage.feat2.check3' | translate }}</li>
              <li><i class="material-icons ico">check_circle</i>{{ 'LANDING.landBookingPage.feat2.check4' | translate }}</li>
            </ul>
            <button (click)="analyticsEvent('bookingPage-customProcess-signup')" class="btn btn-lg btn-secondary mb-3" routerLink="/signup">
              {{ landing.registerCta }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="n-section block-feat pt-5 pb-5">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-md-6 mb-3">
          <img responsiveImg url="nl3-5.png" mobileWidth="400" desktopWidth="820" alt="" />
        </div>
        <div class="col-md-6 mb-3">
          <div class="section-content">
            <h2 class="h2-2 text-primary mb-4">{{ 'LANDING.landBookingPage.feat3.title' | translate }}</h2>
            <p class="large text-gray">{{ 'LANDING.landBookingPage.feat3.desc' | translate }}</p>
            <ul class="text-gray check-list mb-4">
              <li><i class="material-icons ico">check_circle</i>{{ 'LANDING.landBookingPage.feat3.check1' | translate }}</li>
            </ul>
            <button
              (click)="analyticsEvent('bookingPage-onlinePayments-signup')"
              class="btn btn-lg btn-secondary mb-3"
              routerLink="/signup"
            >
              {{ landing.registerCta }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="n-section block-feat pt-5 pb-5">
    <div class="container">
      <div class="row align-items-center flex-md-row-reverse">
        <div class="col-md-6 mb-3">
          <img responsiveImg url="nl3-4.png" mobileWidth="400" desktopWidth="820" alt="" />
        </div>
        <div class="col-md-6 mb-3">
          <div class="section-content">
            <h2 class="h2-2 text-primary mb-4">{{ 'LANDING.landBookingPage.feat4.title' | translate }}</h2>
            <ul class="text-gray check-list mb-4">
              <li><i class="material-icons ico">check_circle</i>{{ 'LANDING.landBookingPage.feat4.check1' | translate }}</li>
              <li><i class="material-icons ico">check_circle</i>{{ 'LANDING.landBookingPage.feat4.check2' | translate }}</li>
            </ul>
            <button (click)="analyticsEvent('bookingPage-googleReviews-signup')" class="btn btn-lg btn-secondary mb-3" routerLink="/signup">
              {{ landing.registerCta }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="n-section block-feat pt-5 pb-5">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-md-6 mb-3">
          <img responsiveImg url="nl-loyalty.png" mobileWidth="400" desktopWidth="820" alt="" />
        </div>
        <div class="col-md-6 mb-3">
          <div class="section-content">
            <h2 class="h2-2 text-primary mb-4">{{ 'LANDING.landBookingPage.feat6.title' | translate }}</h2>
            <p class="large text-gray">{{ 'LANDING.landBookingPage.feat6.desc' | translate }}</p>
            <ul class="text-gray check-list mb-4">
              <li><i class="material-icons ico">check_circle</i>{{ 'LANDING.landBookingPage.feat6.check1' | translate }}</li>
              <li><i class="material-icons ico">check_circle</i>{{ 'LANDING.landBookingPage.feat6.check2' | translate }}</li>
              <li><i class="material-icons ico">check_circle</i>{{ 'LANDING.landBookingPage.feat6.check3' | translate }}</li>
            </ul>
            <button (click)="analyticsEvent('bookingPage-bookingLink-signup')" class="btn btn-lg btn-secondary mb-3" routerLink="/signup">
              {{ landing.registerCta }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="n-section block-feat pt-5 pb-5">
    <div class="container">
      <div class="row align-items-center flex-md-row-reverse">
        <div class="col-md-6 mb-3">
          <img responsiveImg url="nl-extra-fields.png" mobileWidth="400" desktopWidth="820" alt="" />
        </div>
        <div class="col-md-6 mb-3">
          <div class="section-content">
            <h2 class="h2-2 text-primary mb-4">{{ 'LANDING.landBookingPage.feat7.title' | translate }}</h2>
            <p class="large text-gray">{{ 'LANDING.landBookingPage.feat7.desc' | translate }}</p>
            <ul class="text-gray check-list mb-4">
              <li><i class="material-icons ico">check_circle</i>{{ 'LANDING.landBookingPage.feat7.check1' | translate }}</li>
              <li><i class="material-icons ico">check_circle</i>{{ 'LANDING.landBookingPage.feat7.check2' | translate }}</li>
            </ul>
            <button (click)="analyticsEvent('bookingPage-bookingLink-signup')" class="btn btn-lg btn-secondary mb-3" routerLink="/signup">
              {{ landing.registerCta }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="n-section block-feat pt-5 pb-5">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-md-6 mb-3">
          <img responsiveImg url="nl-QR-code.png" mobileWidth="400" desktopWidth="820" alt="" />
        </div>
        <div class="col-md-6 mb-3">
          <div class="section-content">
            <h2 class="h2-2 text-primary mb-4">{{ 'LANDING.landBookingPage.feat8.title' | translate }}</h2>
            <p class="large text-gray">{{ 'LANDING.landBookingPage.feat8.desc' | translate }}</p>
            <ul class="text-gray check-list mb-4">
              <li><i class="material-icons ico">check_circle</i>{{ 'LANDING.landBookingPage.feat8.check1' | translate }}</li>
              <li><i class="material-icons ico">check_circle</i>{{ 'LANDING.landBookingPage.feat8.check2' | translate }}</li>
            </ul>
            <button (click)="analyticsEvent('bookingPage-bookingLink-signup')" class="btn btn-lg btn-secondary mb-3" routerLink="/signup">
              {{ landing.registerCta }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="n-section block-feat pt-5 pb-5">
    <div class="container">
      <div class="row align-items-center flex-md-row-reverse">
        <div class="col-md-6 mb-3">
          <img responsiveImg url="nl3-3.png" mobileWidth="400" desktopWidth="820" alt="" />
        </div>
        <div class="col-md-6 mb-3">
          <div class="section-content">
            <h2 class="h2-2 text-primary mb-4">{{ 'LANDING.landBookingPage.feat5.title' | translate }}</h2>
            <p class="large text-gray">{{ 'LANDING.landBookingPage.feat5.desc' | translate }}</p>
            <ul class="text-gray check-list mb-4">
              <li><i class="material-icons ico">check_circle</i>{{ 'LANDING.landBookingPage.feat5.check1' | translate }}</li>
              <li><i class="material-icons ico">check_circle</i>{{ 'LANDING.landBookingPage.feat5.check2' | translate }}</li>
              <li><i class="material-icons ico">check_circle</i>{{ 'LANDING.landBookingPage.feat5.check3' | translate }}</li>
            </ul>
            <button (click)="analyticsEvent('bookingPage-bookingLink-signup')" class="btn btn-lg btn-secondary mb-3" routerLink="/signup">
              {{ landing.registerCta }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="bg-2 text-center n-section">
    <div class="container">
      <div class="row">
        <div class="col">
          <h1 class="h1-2 mt-5 mb-5">{{ landing.testimoniesTitle }}</h1>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6" *ngFor="let testemony of landing.testemonies">
          <div class="ballon mb-3">
            <p class="mb-0">"{{ testemony.text }}"</p>
          </div>
          <div class="client-review">
            <img src="{{ testemony.image }}" alt="" />
            <p class="mb-0 text-bold">{{ testemony.person }}</p>
            <p class="mb-0 text-gray">{{ testemony.buisiness }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="bg-2 text-center section-carousel" *ngIf="landing.businesses?.length">
    <h2 class="h2-2 mb-5">{{ 'LANDING.landing.everyBusiness' | translate }}</h2>
    <div class="carousel">
      <a
        routerLink="{{ buisiness.urls[language] }}"
        *ngFor="let buisiness of landing.businesses"
        class="box-business block"
        style="background-image: url('/assets/{{ buisiness.class }}.jpg');"
      >
        <h3 class="mb-0">{{ buisiness.text }}</h3>
      </a>
    </div>
  </section>

  <section class="n-section" id="pricing">
    <app-pricing></app-pricing>
  </section>

  <section class="bg-blue n-section">
    <div class="container-fluid">
      <div class="row">
        <div class="col text-center">
          <h1 class="h1-2 mb-5">{{ 'LANDING.landing.help' | translate }} 🙋</h1>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-md-6">
          <accordion [closeOthers]="true">
            <accordion-group heading="{{ 'LANDING.faqs.q1' | translate }}">
              <div [innerHTML]="'LANDING.faqs.a1' | translate"></div>
            </accordion-group>
            <accordion-group heading="{{ 'LANDING.faqs.q2' | translate }}">
              <div [innerHTML]="'LANDING.faqs.a2' | translate"></div>
            </accordion-group>
            <accordion-group heading="{{ 'LANDING.faqs.q5b' | translate }} {{ landing.buisiness?.toLowerCase() }}?">
              <div [innerHTML]="'LANDING.faqs.a5' | translate"></div>
            </accordion-group>
            <accordion-group heading="{{ 'LANDING.faqs.q11' | translate }}">
              <div [innerHTML]="'LANDING.faqs.a11' | translate"></div>
            </accordion-group>
          </accordion>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col text-center">
          <button class="btn btn-lg btn-secondary mr-3" routerLink="/faqs">
            <a routerLink="/faqs">{{ 'LANDING.landing.featuresPanel8.text' | translate }} →</a>
          </button>
        </div>
      </div>
    </div>
  </section>

  <section class="bg-blue-dark n-section">
    <div class="container pt-5 pb-5">
      <div class="row justify-content-center text-center">
        <div class="col-md-8">
          <h1 class="h1-2 mb-5">{{ 'LANDING.landing.ctaSection.title' | translate }}</h1>
          <p class="large mb-5">{{ 'LANDING.landing.ctaSection.text' | translate }}</p>
          <div class="d-flex justify-content-center mb-3 desktop-only">
            <button (click)="analyticsEvent('bookingPage-CTAsection-signup')" class="btn btn-lg btn-secondary mr-3" routerLink="/signup">
              {{ landing.registerCta }}
            </button>
            <a
              (click)="analyticsEvent('bookingPage-CTAsection-demo')"
              class="btn btn-lg btn-secondary-outline"
              target="_blank"
              [href]="toolsService.getDemoLink()"
              >{{ landing.contactCta }}</a
            >
          </div>
          <div class="d-flex flex-column justify-content-center mb-3 mobile-only">
            <button (click)="analyticsEvent('bookingPage-CTAsection-signup')" class="btn btn-lg btn-secondary mb-3" routerLink="/signup">
              {{ landing.registerCta }}
            </button>
            <a
              (click)="analyticsEvent('bookingPage-CTAsection-demo')"
              class="btn btn-lg btn-secondary-outline mb-3"
              target="_blank"
              [href]="toolsService.getDemoLink()"
              >{{ landing.contactCta }}</a
            >
          </div>
          <a routerLink="/signup" *ifCountry="'pt'">
            <p class="pro-code text-white small mb-5">
              ⚡️ {{ 'LANDING.landing.promoCopy' | translate }}
            </p>
          </a>
          <a routerLink="/signup" *ifCountry="'es'">
            <p class="pro-code text-gray small mb-5">
              ⚡️ {{ 'LANDING.pricing.tryPro' | translate }}
            </p>
          </a>
        </div>
      </div>
    </div>
  </section>

  <section class="footer n-section bg-2">
    <div class="container-fluid">
      <div class="row">
        <div class="col">
          <div class="footer-wrap">
            <div class="row mb-4">
              <div class="col-md-3 mb-4">
                <span class="logo mb-2"></span>
                <p>{{ 'LANDING.landing.reachOut' | translate }} <a href="mailto:{{supportEmail}}">{{supportEmail}}</a></p>
              </div>
              <div class="col-md-3 mb-4">
                <ul>
                  <li>
                    <a rel="canonical" [routerLink]="language === 'pt' ? '/agenda' : '/calendar'">{{ 'LANDING.nav.calendar' | translate }}</a>
                  </li>
                  <li>
                    <a rel="canonical" [routerLink]="language === 'pt' ? '/pagina-marcacoes' : '/booking-page'">{{ 'LANDING.nav.bookingPage' | translate }}</a>
                  </li>
                  <li>
                    <a rel="canonical" [href]="language === 'pt' ? '/pagina-marcacoes#pricing' : '/booking-page#pricing'" (click)="analyticsEvent('navbar-pricing')">{{ 'LANDING.nav.pricing' | translate }}</a>
                  </li>
                  <li>
                    <a rel="canonical" routerLink="/faqs">{{ 'LANDING.landing.faqs' | translate }}</a>
                  </li>
                  <li class="open-help-modal">
                    <a (click)="showHelpModal()">{{ 'LANDING.landing.help' | translate }}</a>
                  </li>
                  <li>
                    <a rel="canonical" [href]="'https://blog.' + host">{{ 'LANDING.landing.blog' | translate }}</a>
                  </li>
                </ul>
              </div>
              <div class="col-md-3 mb-4">
                <ul>
                  <li>
                    <a target="_blank" rel="canonical" routerLink="/terms">{{ 'LANDING.landing.terms' | translate }}</a>
                  </li>
                  <li>
                    <a target="_blank" rel="canonical" routerLink="/privacy">{{ 'LANDING.landing.privacy' | translate }}</a>
                  </li>
                  <li>
                    <a target="_blank" rel="canonical" routerLink="/cookie-policy">{{ 'LANDING.landing.cookies' | translate }}</a>
                  </li>
                </ul>
              </div>
              <div class="col-md-3 mb-4">
                <ul>
                  <li>
                    <div class="d-flex socials">
                      <a target="_blank" href="https://www.facebook.com/bukapp"><img src="assets/svg-fb.svg" alt="" /></a>
                      <a *ifCountry="'pt'" target="_blank" href="https://www.instagram.com/buk.pt"><img src="assets/svg-ig.svg" alt="" /></a>
                      <a *ifCountry="'es'" target="_blank" href="https://www.instagram.com/buk.app.es"><img src="assets/svg-ig.svg" alt="" /></a>
                      <a *ifCountry="'us'" target="_blank" href="https://www.instagram.com/buk.app"><img src="assets/svg-ig.svg" alt="" /></a>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="row">
              <div class="col text-center">
                <p class="mb-0">
                  {{ 'LANDING.landing.footerText1' | translate }} <a target="_blank" href="https://uvstudio.co">uvstudio.co</a> •
                  {{ 'LANDING.landing.footerText2' | translate }} 🇵🇹
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</ng-container>

<app-whatsapp-cta></app-whatsapp-cta>
